<template lang="pug">
d2-container
  el-form(
    :inline="true",
    :model="dataForm",
    size="mini",
    label-position="left",
    label-width="75px",
    label-suffix=":"
  )
    el-row(:span="24")
      el-col(:md="7", :sm="12")
        el-form-item(label="标题")
          el-input(
            style="width: 210px",
            v-model="dataForm.title",
            clearable=""
          )
      el-col(:md="7", :sm="12")
        el-form-item(label="主办方")
          el-select(
            style="width: 210px",
            v-model="dataForm.orgId",
            placeholder="请选择",
            filterable,
            clearable
          )
            el-option(
              v-for="(item, index) in sysOrgList",
              :key="index",
              :label="item.name",
              :value="item.orgId"
            )
      el-col(:md="7", :sm="12")
        el-form-item(label="创建时间")
          el-date-picker(
            style="width: 210px",
            v-model="dataForm.createTime",
            range-separator="至",
            type="daterange",
            start-placeholder="开始日期",
            end-placeholder="结束日期",
            value-format="yyyy-MM-dd"
          )
  el-row(style="padding-bottom: 15px")
    el-col(:span="23")
      el-button(
        @click="addOrUpdateHandle()",
        type="primary",
        v-if="isAuth('pb:rotary:add')"
      ) 新建
      el-button(
        @click="publish()",
        type="primary",
        :disabled="dataListSelections.length <= 0",
        v-if="isAuth('pb:rotary:publish')"
      ) 发布
      el-button(
        @click="cancelPublish()",
        type="primary",
        v-if="isAuth('pb:rotary:cancelPublish')"
      ) 撤回
      el-button(
        @click="deleteitem(dataListSelections)",
        type="danger",
        :disabled="dataListSelections.length <= 0",
        v-if="isAuth('pb:rotary:del')"
      ) 删除
      el-button(
        @click="toppings()",
        type="primary",
        v-if="isAuth('pb:rotary:cancelPublish')"
      ) 置顶
    el-col(:md="1", :sm="14", style="float: right")
      el-button(
        @click="getDataList()",
        type="primary",
        icon="el-icon-search",
        style="float: right"
      ) 查 询
  el-table#out-table(
    :data="tableData",
    style="width: 100%",
    @selection-change="selectionChangeHandle",
    v-loading="dataListLoading",
    border
  )
    el-table-column(
      type="selection",
      header-align="center",
      align="center",
      width="50"
    )
    el-table-column(
      prop="title",
      header-align="center",
      align="center",
      label="标题"
    )
    el-table-column(
      prop="orgName",
      header-align="center",
      align="center",
      label="主办方"
    )
    el-table-column(
      prop="createTime",
      header-align="center",
      align="center",
      label="创建时间"
    )
    //- el-table-column(prop='url',header-align='center',align='center',label='关联资讯')
    el-table-column(
      prop="status",
      header-align="center",
      align="center",
      label="状态"
    )
      template(slot-scope="scope")
        font(v-if="scope.row.status === 1") 新建
        font(v-if="scope.row.status === 2") 已发布
        font(v-if="scope.row.status === 3") 已撤回
    el-table-column(
      prop="",
      header-align="center",
      align="center",
      label="操作",
      width="100"
    )
      template(slot-scope="scope")
        el-menu.menuPonit(
          @open="handleOpen",
          @close="handleClose",
          :collapse="isCollapse"
        )
          el-submenu(index="1")
            template(slot="title")
              i.el-icon-more(style="color: #02b90d")
            el-menu-item-group
              el-menu-item(
                index="1-2",
                @click="addOrUpdateHandle(scope.row.id)",
                v-if="isAuth('pb:rotary:update')"
              ) 修改
              el-menu-item(
                index="1-3",
                @click="deleteitem(scope.row.id)",
                v-if="isAuth('pb:rotary:del')"
              ) 删除
              el-menu-item(
                index="1-4",
                @click="topping(scope.row.id)",
                v-if="isAuth('pb:rotary:del')"
              ) 置顶
  el-pagination(
    @size-change="sizeChangeHandle",
    @current-change="currentChangeHandle",
    :current-page="pageIndex",
    :page-sizes="[10, 20, 50, 100]",
    :page-size="pageSize",
    :total="totalPage",
    layout="total, sizes, prev, pager, next, jumper"
  )
  //新增-修改
  add-or-update(
    v-if="addOrUpdateVisible",
    ref="addOrUpdate",
    @refreshDataList="getDataList"
  )
</template>
<script>
import "../../../util/jquery-3.3.1.min";
import AddOrUpdate from "./add-or-update";
export default {
  name: "mb-member",
  data() {
    return {
      isCollapse: true,
      dataForm: {
        title: "",
        createTime: "",
        orgId: "",
      },
      orgName: "",
      ids: new Array(),
      tableData: [],
      rightData: [],
      leftData: [],
      argueData: [],
      nowSelectData: [], // 左边选中列表数据
      nowSelectRightData: [], // 右边选中列表数据
      dataListSelections: [],
      sysOrgList: [],
      pageIndex: 1,
      pageIndex1: 1,
      pageSize: 10,
      pageSize1: 10,
      totalPage: 0,
      totalPage1: 0,
      dataListLoading: false,
      memberOrgListLoading: false,
      startScoreMin: "",
      StartScoreMax: Infinity,
      endScoreMin: "",
      addOrUpdateVisible: false,
      viewVisible: false,
      dialogFormVisible: false,
      gameVisible: false,
      argueVisible: false,
      senseVisible: false,
      orgIdList: [],
    };
  },
  components: {
    AddOrUpdate,
  },
  created() {
    this.getDataList();
    this.changeOrg();
  },
  methods: {
    toppings() {
      if (this.dataListSelections.length < 1) {
        return this.$message.error("未勾选任何项目！");
      }
      let ids = [];
      this.dataListSelections.forEach((e) => {
        ids.push(e.id);
      });
      ids = ids.join(",");
      this.$confirm("确认置顶？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http({
            url: this.$http.adornUrl(`/pbRotary/topping/${ids}`),
            method: "get",
          }).then((data) => {
            if (data && data.code === 0) {
              this.$message.success("操作成功!");
              this.getDataList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    //推荐或取消推荐
    topping(id) {
      this.$confirm("确定置顶？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http({
            url: this.$http.adornUrl(`/pbRotary/topping/${id}`),
            method: "get",
          }).then((e) => {
            if (e.code === 0) {
              this.$message.success("操作成功！");
              this.getDataList();
            }
          });
        })
        .catch(() => {
          this.$message.info("已取消！");
        });
    },
    handleOpen() {},
    handleClose() {},
    //新增按钮事件
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id);
      });
    },

    // ids，status 状态1.新建2.已发布3.已撤回
    dofabu(status, tip) {
      if (this.dataListSelections.length < 1) {
        return this.$message.error("未勾选任何项目！");
      }
      let ids = [];
      this.dataListSelections.forEach((e) => {
        ids.push(e.id);
      });
      ids = ids.join();
      this.$confirm(tip, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http({
            url: this.$http.adornUrl(`/pbRotary/updateStatus`),
            method: "post",
            params: {
              ids: ids,
              status: status,
            },
          }).then((data) => {
            if (data && data.code === 0) {
              this.$message.success("操作成功!");
              this.getDataList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    publish() {
      this.dofabu(2, "确定发布？");
    },
    cancelPublish() {
      this.dofabu(3, "确定撤回？");
    },
    // 删除
    deleteitem(id) {
      if (typeof id !== "string") {
        if (id.length == 0) return this.$message.error("未勾选任何项目！");
        let ids = [];
        id.forEach((e) => {
          ids.push(e.id);
        });
        id = ids.join();
      }
      this.$confirm("此操作将永久删除该轮播图信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http({
            url: this.$http.adornUrl(`/pbRotary/delete/${id}`),
            method: "get",
            params: this.$http.adornParams(),
          }).then((data) => {
            if (data && data.code === 0) {
              this.$message.success("删除成功!");
              this.getDataList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    selectable(row, index) {
      if (row.name == "国奥利贤") {
        return false;
      } else {
        return true;
      }
    },
    getDataList() {
      this.memberOrgListLoading = true;
      console.log(this.rightData);
      this.rightData.forEach((data) => {
        this.orgIdList.push(data.id);
      });
      this.$http({
        url: this.$http.adornUrl("/sysOrg/orgList"),
        method: "get",
        params: this.$http.adornParams({
          page: this.pageIndex1,
          limit: this.pageSize1,
          name: this.orgName,
          orgIdList: JSON.stringify(this.orgIdList),
        }),
      }).then((data) => {
        if (data && data.code === 0) {
          this.leftData = data.page.records;
          this.totalPage1 = data.page.total;
        } else {
          this.leftData = [];
          this.totalPage1 = 0;
        }
        this.memberOrgListLoading = false;
      });
    },
    updateOrg(id) {
      this.mbId = id;
      this.senseVisible = true;
      this.$http({
        url: this.$http.adornUrl("/sysOrg/getBelognList"),
        method: "get",
        params: this.$http.adornParams({
          page: this.pageIndex1,
          limit: this.pageSize1,
          mbId: this.mbId,
        }),
      }).then((data) => {
        if (data && data.code === 0) {
          this.leftData = data.page.records;
          this.rightData = data.list;
          this.totalPage1 = data.page.total;
        } else {
          this.leftData = [];
          this.totalPage1 = 0;
        }
      });
    },
    checkAll(val) {
      this.nowSelectData = val;
    },
    checkRightAll(val) {
      this.nowSelectRightData = val;
    },
    // 选中
    handelSelect() {
      this.rightData = this.handleConcatArr(this.rightData, this.nowSelectData);
      this.handleRemoveTabList(this.nowSelectData, this.leftData);
      this.nowSelectData = [];
    },
    // 取消
    handleRemoveSelect() {
      this.leftData = this.handleConcatArr(
        this.leftData,
        this.nowSelectRightData
      );
      this.handleRemoveTabList(this.nowSelectRightData, this.rightData);
      this.nowSelectRightData = [];
    },
    handleConcatArr(rightData, nowSelectData) {
      let arr = [];
      arr = arr.concat(rightData, nowSelectData);
      return arr;
    },
    handleRemoveTabList(isNeedArr, originalArr) {
      if (isNeedArr.length && originalArr.length) {
        for (let i = 0; i < isNeedArr.length; i++) {
          for (let k = 0; k < originalArr.length; k++) {
            if (isNeedArr[i]["name"] === originalArr[k]["name"]) {
              originalArr.splice(k, 1);
            }
          }
        }
      }
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val;
    },
    getDataList() {
      console.log(this.dataForm);
      this.dataListLoading = true;
      let strDate = ''
      let endDate = ''
      if (this.dataForm.createTime && this.dataForm.createTime.length > 0) {
        strDate = this.dataForm.createTime[0]
        endDate = this.dataForm.createTime[1]
      }
      this.$http({
        url: this.$http.adornUrl("/pbRotary/list"),
        method: "post",
        data: {
          page: this.pageIndex,
          limit: this.pageSize,
          title: this.dataForm.title,
          strDate,
          endDate,
          orgId: this.dataForm.orgId,
        },
      }).then((data) => {
        if (data && data.code === 0) {
          this.tableData = data.page.records;
          this.totalPage = data.page.total;
        } else {
          this.tableData = [];
          this.totalPage = 0;
        }
        this.dataListLoading = false;
      });
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    sizeChangeHandle1(val) {
      this.pageSize1 = val;
      this.pageIndex1 = 1;
      this.getDataList();
    },
    changeOrg() {
      this.$http({
        url: this.$http.adornUrl("/sysOrg/list"),
        method: "get",
        params: this.$http.adornParams({
          cityId: "",
          proviceId: "",
        }),
      }).then((data) => {
        this.sysOrgList = data && data.code === 0 ? data.list : [];
      });
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    currentChangeHandle1(val) {
      this.pageIndex1 = val;
      this.getDataList();
    },
  },
};
</script>
<style scope="this api replaced by slot-scope in 2.5.0+" >
/* 操作三点 菜单样式 */
@import "../../css/opr3dot.css";

.el-input-number--mini .el-input__inner {
  padding-left: 25px;
  padding-right: 25px;
}
.el-input-number--mini .el-input-number__decrease,
.el-input-number--mini .el-input-number__increase {
  width: 24px;
  font-size: 12px;
}
.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 0px;
  vertical-align: top;
}
</style>
